import React from "react";
import styled from "styled-components";
import { CharacterResult } from "common/character/dto/CharacterResult";
import RelateAnswerLetter from "components/pages/answer/RelatePlay/relate_answer/RelateAnswerLetter";

export type InputWayTextPlayCharacterProps = {
  character: CharacterResult;
};

const InputWayTextPlayCharacter = ({
  character,
}: InputWayTextPlayCharacterProps) => {
  return (
    <Div>
      <RelateAnswerLetter letter={character.letter} />
    </Div>
  );
};

const Div = styled.div<{ isCharacter?: boolean }>`
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
`;

export default InputWayTextPlayCharacter;
